import type { CtSearchProductsFacet, CtRefinementListItem } from '~~/types/productListing/CtSearchProductsResult';

export const mapCtFacetToRefinementItems = (
  facet: CtSearchProductsFacet | undefined,
  selectedValues: string[] = [],
): CtRefinementListItem[] => {

  return (facet?.buckets || []).map(bucket => ({
    value: bucket.key,
    label: bucket.key,
    count: bucket.count,
    isRefined: selectedValues.includes(bucket.key),
  }));

};
